export default __webpack_public_path__ + "static/media/gatsby.431ab573.png";